// extracted by mini-css-extract-plugin
export var leftAlign = "_1o-2";
export var popper = "_1o-0";
export var subtitle = "_1o-1";